<template>
  <div>
    <apexchart
      v-if="!noData"
      type="bar"
      :height="height"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <div v-else style="text-align: center">
      <div class="w-100">
        <span style="text-align: center">{{ $t(`texts.data.no-products-created`) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AllCuisinesChart",
  data: () => ({
    noData: false,
    series: [],
    chartOptions: {
      colors: [
        "#008FFB",
        "#00E396",
        "#FEB019",
        "#FF4560",
        "#775DD0",
        "#3F51B5",
        "#546E7A",
        "#D4526E",
        "#8D5B4C",
        "#F86624",
        "#D7263D",
        "#1B998B",
        "#2E294E",
        "#F46036",
        "#E2C044",
      ],
      chart: {
        type: "bar",
        stacked: true,
        stackType: "100%",
      },
      plotOptions: {
        bar: {
          horizontal: true,
        },
      },
      stroke: {
        width: 1,
        colors: ["#fff"],
      },
      title: {
        text: "",
      },
      xaxis: {
        title: {
          text: "Percentage",
        },
        categories: [],
      },
      yaxis: {
        min: 1,
        title: {
          text: "Round",
        },
      },
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: true,
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + " products";
          },
        },
      },
      fill: {
        opacity: 1,
      },
      legend: {
        position: "top",
        horizontalAlign: "left",
        offsetX: 40,
      },
    },
  }),
  computed: {
    ...mapGetters([
      "gameProducts",
      "activeGame",
      "productCategories",
      "gameAllTeams",
      "ownerCurrentGame",
    ]),
    turn() {
      return this.activeGame.turn;
    },
    generateAllNumbers() {
      let arr = [];
      if (this.isArchived()) {
        for (let i = 1; i <= this.turn; i++) {
          arr.push(i);
        }
      } else {
        for (let i = 1; i < this.turn; i++) {
          arr.push(i);
        }
      }
      return arr;
    },
  },
  created() {
    this.createChart();
    this.setTitle();
  },
  props: {
    selectedTeam: Number,
    height: Number,
  },
  watch: {
    selectedTeam() {
      this.reset();
      this.createChart();
      this.setTitle();
    },
    gameProducts: function () {
      this.reset();
      this.createChart();
      this.setTitle();
    },
  },
  methods: {
    reset: function () {
      this.series = [];
      this.chartOptions.labels = [];
      this.chartOptions.xaxis.categories = [];
    },
    async createChart() {
      this.generateAllNumbers.forEach((round) =>
        this.chartOptions.xaxis.categories.push(round)
      );

      let local = this.gameProducts;
      let sortedCategories = this.productCategories.sort(this.compare);
      if (!local || !local.length > 0) {
        this.noData = true;
        return false;
      }
      local.forEach((r) => {
        this.series.push({
          name: sortedCategories.find((c) => c.id === r.id).name,
          data: this.selectedTeam
            ? this.createData(r.results.filter((r) => r.teamId === this.selectedTeam))
            : this.createData(r.results),
        });
      });
    },
    createData(results) {
      let data = [];
      this.generateAllNumbers.forEach((round) => {
        let allRounds = [];
        for (let i = 1; i <= round; i++) {
          allRounds.push(i);
        }
        if (results.some((d) => allRounds.includes(d.turn))) {
          let filtered = results.filter((result) => allRounds.includes(result.turn));
          data.push(filtered.length);
        } else {
          data.push(0);
        }
      });
      return data;
    },
    compare(a, b) {
      let comparison = 0;
      if (a.name > b.name) {
        comparison = 1;
      } else if (a.name < b.name) {
        comparison = -1;
      }
      return comparison;
    },
    setTitle() {
      this.chartOptions = {
        ...this.chartOptions,
        title: {
          text: this.selectedTeam
            ? `Cuisines ratio of team  ${
                this.gameAllTeams.find((t) => t.id === this.selectedTeam).name
              }`
            : "Cuisines ratio",
        },
      };
    },
    isArchived() {
      return this.ownerCurrentGame.endedTime != null;
    },
  },
};
</script>
